import { useEffect, useState } from "react";
import { Skeleton, Typography } from "@mui/material";
import { makeStyles } from "@/compat/muiStyles";
import useBrandingLogo from "../../hooks/queries/useBrandingLogo";

const useStyles = makeStyles((theme) => ({
    logo: { maxHeight: 40, maxWidth: 160, objectFit: "contain", display: "block" },
    none: { color: theme.palette.text.secondary },
}));

interface BrandingLogoProps {
    reference?: string | null;
    fileName?: string | null;
}

export default function BrandingLogo({ reference, fileName }: BrandingLogoProps) {
    const classes = useStyles();
    const logo = useBrandingLogo(reference);
    const [src, setSrc] = useState<string | null>(null);

    useEffect(() => {
        if (!logo?.data) {
            setSrc(null);
            return;
        }

        const objectUrl = URL.createObjectURL(logo.data as Blob);
        setSrc(objectUrl);

        return () => URL.revokeObjectURL(objectUrl);
    }, [logo?.data]);

    if (!reference) return <Typography className={classes.none}>None</Typography>;

    // A logo can take a moment to come back from storage; an empty cell reads as
    // "no logo", so show that it's still coming.
    if (!src) return <Skeleton variant="rectangular" width={120} height={40} />;

    return <img className={classes.logo} src={src} alt={fileName ?? "Logo"} />;
}
